<template>
  <div>
    <div class="d-flex justify-content-between">
      <ministry-breadcrumbs
        class="w-75"
        :mainTitle="mainTitle"
        :breadcrumbs="breadcrumbs"
      />
      <div v-can="{ slug: $route.meta.slug, action: 'C' }">
        <b-button variant="success" @click="onNewClicked">إضافة</b-button>
      </div>
    </div>

    <b-card>
      <div style="position: relative">
        <loading-overlay v-if="loading" :loading="loading" />
        <b-table-lite
          bordered
          v-else
          hover
          small
          :items="tableData"
          :fields="fields"
        >
          <template #cell(icon)="{ item }">
            <div class="d-flex align-items-center">
              <img
                :src="require(`@/assets/contacts/${item.icon}.png`)"
                width="25px"
                height="25px"
              />
            </div>
          </template>
          <template #cell(actions)="{ item }">
            <div class="d-flex justify-content-end">
              <b-button
                v-can="{ slug: $route.meta.slug, action: 'U' }"
                size="sm"
                @click="onEditClicked(item)"
                variant="flat-info"
                class="btn-icon rounded-circle"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                v-can="{ slug: $route.meta.slug, action: 'D' }"
                size="sm"
                @click="onDeleteClicked(item.id)"
                variant="flat-danger"
                class="btn-icon rounded-circle"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </div>
          </template>
        </b-table-lite>
      </div>
    </b-card>
    <form-modal
      v-model="showIndexModal"
      title="معلومات الفهرس"
      ref="indexModal"
      @confirm="onConfirm"
      :formSchema="formSchema"
      :loading="loading || working"
    >
      <template #iso_code="{ form }">
        <validation-provider
            mode="passive"
            #default="{ errors }"
            name="iso code"
            rules="required|min:3|max:3"
          >
            <form-input
              v-model="form.iso_code"
              label="iso_code"
            />
            <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        
      </template>
    </form-modal>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BListGroup,
  BListGroupItem,
  BTableLite,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { mapGetters, mapActions } from "vuex";
import FormModal from "@/components/FormModal.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormInput from "@/components/form-input";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import indexes from "./indexes-data";
import {
  required,
  min,
  digits,
  length,
  max,
} from "@validations";
export default {
  components: {
    BCard,
    BButton,
    BListGroup,
    BListGroupItem,
    MinistryBreadcrumbs,
    BTableLite,
    FormModal,
    LoadingOverlay,
    ToastificationContent,
    FormInput , ValidationProvider, ValidationObserver , required,
    min,
    digits,
    length,
    max,
  },
  props: {
    slug: String,
  },
  data() {
    return {
      showIndexModal: false,
      indexes: indexes,
      mainTitle: "الفهارس",
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "الفهارس",
          to: "/ministry/settings/indexes",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("Ministry/Settings/Indexes", [
      "loading",
      "working",
      "tableData",
      "fields",
      "formSchema",
    ]),
  },
  methods: {
    ...mapActions("Ministry/Settings/Indexes", [
      "initState",
      "refreshData",
      "store",
      "update",
      "delete",
    ]),
    async onConfirm(form) {
      if (form.id) {
        await this.update(form);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } else {
        await this.store(form);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      }
      this.showIndexModal = false;
    },
    onNewClicked() {
      this.showIndexModal = true;
    },
    onEditClicked(form) {
      if(form.hasOwnProperty('classification')){
        form.classification_id = form.classification
      }
      this.$refs.indexModal.init(form);
      this.showIndexModal = true;
    },
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الفهرس ؟", {
          title: "تأكيد حذف الفهرس",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            if (this.tableData.length > 1)
              this.delete(id).then(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "تم الحذف بنجاح",
                    icon: "CheckSquareIcon",
                    variant: "success",
                    timeout: 3000,
                  },
                });
              });
            else
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "يجب أن تحتوي الفهارس على سجل واحد على الأقل",
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                  timeout: 8000,
                },
              });
          }
        });
    },
  },
  created() {
    this.initState({
      slug: this.slug,
      vue: this,
    });
    this.breadcrumbs.push({
      text: this.indexes.find((el) => el.slug === this.slug).title,
      active: true,
    });
  },
};
</script>
